@import "../../global/base.scss";

#home_container {
    .tools-tile-group {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        width: 100%;
    }

    .tools-tile {
        margin: $tile-margin;
        min-width: $tile_width;
        max-width: $tile_width;
        min-height: $tile_height;
        max-height: $tile_height;

        .learn-more {
            display: flex;
            align-items: center;;

            .arrow {
                border: solid #cc0000;
                border-width: 0 3px 3px 0;
                padding: 3px;
                margin-left: 10px;
                transform: rotate(-45deg);
                -webkit-transform: rotate(-45deg);
            }
        }
    }

    #welcome_section {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding: $section_padding;
        padding-bottom: 120px;
        background-color: $section-background-color;
        column-gap: 80px;

        #welcome_text_container {
            flex: 1;
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            margin-bottom: 20px;
            max-width: 930px;
            min-width: 300px;

            #welcome_heading_text {
                margin-bottom: 16px;
                --gc-font-size: 36px;
                --gc-font-weight: 200;
            }

            #welcome_info {
                line-height: 20px;
                --gc-line-height: 20px;
            }
        }

        #welcome_video {
            position: relative;
            width: 480px;
            min-width: 480px;
            height: 270px;
            min-height: 270;

            box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%),
                        0 1px 5px 0 rgb(0 0 0 / 12%),
                        0 3px 1px -2px rgb(0 0 0 / 20%);

            #video_player {
                border: none;
            }
        }
    }

    #device_detector_section {
        display: flex;
        flex-direction: column;
        padding: $section_padding;

        gc-widget-device-detector-getting-started {
            box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%),
                        0 1px 5px 0 rgb(0 0 0 / 12%),
                        0 3px 1px -2px rgb(0 0 0 / 20%);
            padding: 40px 20px;
            margin: 0;
            margin-top: -120px;
            --gc-action-icon-color: #{$link-color};
        }

        #ti_cloud_agent_extension {
            display: flex;
            flex-direction: column;
            justify-content: center;

            #device_detector_info_no_selection,
            #device_detector_info_cloud_agent {
                display: flex;
                align-items: center;
                margin: 30px 0 0;
                font-size: 14px;
            }
        }

        #order_now_btn {
            align-self: center;
            margin-left: 30px;
        }
    }

    #common_action_section {
        display: flex;
        flex-direction: column;
        padding: $section_padding;
        padding-top: 0;

        #common_action_title {
            --gc-font-size: 26px;
            --gc-font-weight: 200;
            margin-bottom: 20px;
        }

        #common_action_group {
            display: flex;
            flex-wrap: wrap;

            gc-widget-container {
                padding: 20px 0;
                width: 350px;
                margin: 0 10px;
                background-color: transparent;;

                .icon {
                    cursor: pointer;
                    margin: 0 20px 0 0;
                    width: 48px;
                    height: 48px;
                    -webkit-mask-size: 100% 100%;
                    mask-size: 100% 100%;
                    background-color: #{$link-color};
                }

                .text-container {
                    flex: 1;
                    display: flex;
                    flex-direction: column;

                    > .desc {
                        margin-top: 10px;
                        font-size: 14px;
                        line-height: 20px;
                    }
                }
            }
        }
    }

    #tool_section {
        background-color: $section-background-color;
        padding: $section_padding;
        display: flex;
        flex-direction: column;
        align-items: center;;

        #tool_section_show_all_tools {
            width: 240px;
            margin-bottom: 30px;
            --gc-background-color: transparent;
        }

        gc-widget-tab-container {
            background-color: transparent;
            height: auto;
            width: 100%;

            gc-widget-tab-panel {
                width: 100%;
                position: relative;
                background-color: transparent;

                .tool-tab-description {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    margin: 20px 0;
                }

                .tool-tab-description-action {
                    white-space: nowrap;
                    display: flex;;
                }

                gc-widget-label {
                    &.description {
                        --gc-font-size: 20px;
                        --gc-font-weight: 100;

                        &.tab {
                            margin: 10px 0;
                        }
                    }
                }

                #ccs_tile {
                    width: calc($tile_width * 2 + $tile_margin * 2);
                    height: $tile_height;
                    margin: $tile-margin;

                    #desktop_tools_download_group {
                        display: flex;
                        align-items: center;
                        gc-widget-button {
                            margin: 0 10px 0 0;
                        }

                        #desktop_tools_download_link_group {
                            display: flex;
                            flex-direction: column;

                            gc-widget-label {
                                margin: 0;
                                width: fit-content;
                                --gc-font-size: 12px;
                            }
                        }
                    }
                }

                #desktop_tools_filter {
                    width: 250px;
                }
            }
        }
    }
}
